export default __webpack_public_path__ + "static/media/uv22_en_star_b1.0554af75.mp3";